import {Link, useSearchParams} from "react-router-dom";
import {useLocation} from 'react-router-dom';
import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import SvgIcon from "../svg-icon";
import SidebarLanguage from "./language";
import {useTranslation} from "react-i18next";
import SidebarSmall from "./sidebar-small";
import ClassWatcher from "../../hooks/ClassWatcher";
import SidebarRaces from "./sidebar-races";
import StyleHelper from "../../helpers/styleHelper";
import store from "../../reducers/createReducers";
import {GLOBAL_CONSTANTS} from "../../constants/global-constants";
import {show} from '@intercom/messenger-js-sdk';
import stringHelper from "../../helpers/string-helper";
import associateServices from "../../services";
import Big from "big.js";
import SpriteSvg from "../../assets/svg/sprite.svg";
import WheelIcon from "../wheel-icon";
import {toast} from "react-toastify";
import InformationToast from "../toast/InformationToast";

const Sidebar = (props) => {

    const {i18n} = useTranslation();
    const currentLanguage = i18n.language; // Get the current language


    const {authenticated, selectedWallet} = useSelector(state => state.authenticationReducer)
    const {configuration, agent, activeLanguage} = useSelector(state => state.globalReducer)
    const {gameTypes, liveCasinoTypes, sportsbookTypes} = useSelector(state => state.dataReducer)

    const [liveCasinoGroups, setLiveCasinoGroups] = useState([])
    const [slotCasinoGroups, setSlotCasinoGroups] = useState([])
    // const {} = useSelector(state => state.globalReducer)
    const [searchParams, setSearchParams] = useSearchParams()

    const [collapsed, setCollapsed] = useState([])


    // const navigate = useNavigate()
    const location = useLocation()
    const {t} = useTranslation()

    // const handleNavigation = path => navigate(path)

    const handleLiveSupport = () => {
        if (window?.Comm100API) {
            try {
                console.log('window?.Comm100API = ', window?.Comm100API)
                const dd2 = document.getElementById('comm100-container')
                console.log('dd2  = ', dd2)
                if (dd2)
                    dd2.style.display = 'block'; // Hide each chat button


                const chatButtons = document.querySelectorAll('[id^="comm100-button-"]');
                chatButtons?.forEach((chatButton) => {
                    chatButton.style.display = 'block'; // Hide each chat button
                    chatButton.style.visibility = 'visible'; // Hide overlay or blocking elements
                });

                // Hide potential overlays or other related elements
                const chatOverlays = document.querySelectorAll('.comm100-livechat-overlay, .comm100-livechat-widget');
                chatOverlays?.forEach((overlay) => {
                    overlay.style.display = 'block'; // Hide overlay or blocking elements
                    overlay.style.visibility = 'visible'; // Hide overlay or blocking elements
                });


                window?.Comm100API?.do('livechat.button.click');


                window?.Comm100API?.open_chat_window();
                window?.Comm100API?.openChatWindow();
            } catch (e) {
                console.error(e)
            }
        } else {
            try {
                show()
            } catch (e) {
                console.error(e)
            }
        }

    }


    useEffect(() => {

        const ii = slotCasinoGroups?.find(pp => location?.pathname?.includes(`casino/group/${pp?.slug}`))
        if (ii)
            setCollapsed(['slots'])
        else {
            const ii = liveCasinoGroups?.find(pp => location?.pathname?.includes(`casino/group/${pp?.slug}`))
            if (ii)
                setCollapsed(['live-casino'])

        }

    }, [slotCasinoGroups, liveCasinoGroups, location.pathname])

    const [active, setActive] = useState('homepage')

    const getPluckedPath = (url) => {
        // const url = "/tr/casino/group/megaways-games";
        return url.split("/").filter(Boolean).pop();


    }

    useEffect(() => {
        if (location?.pathname === '/vip' || location?.pathname === `/${currentLanguage}/vip`)
            setActive('vip')
        else if (location?.pathname === '/wheel' || location?.pathname === `/${currentLanguage}/wheel`)
            setActive('wheel')
        else if (location?.pathname === '/blog' || location?.pathname === `/${currentLanguage}/blog`)
            setActive('blog')
        else if (location?.pathname === '/challenges' || location?.pathname === `/${currentLanguage}/challenges`)
            setActive('challenges')
        else if (location?.pathname === '/streams' || location?.pathname === `/${currentLanguage}/streams`)
            setActive('streams')
        else if (location?.pathname === '/casino/slots' || location?.pathname === `/${currentLanguage}/casino/slots`) {
            setActive('slots')
            setCollapsed(['slots'])
        } else if (location?.pathname === '/live-casino' || location?.pathname === `/${currentLanguage}/live-casino`) {
            setActive('live-casino')
            setCollapsed(['live-casino'])
        } else if (location?.pathname === '/sportsbook' || location?.pathname === `/${currentLanguage}/sportsbook`) {
            setActive('sportsbook')
            setCollapsed(['sportsbook'])
        } else if (location?.pathname === '/casino' || location?.pathname === `/${currentLanguage}/casino`)
            setActive('casino')
        else if (location?.pathname === '/policy' || location?.pathname === `/${currentLanguage}/policy`)
            setActive('policy')
        else if (location?.pathname === '/tournaments' || location?.pathname === `/${currentLanguage}/tournaments`)
            setActive('tournaments')
        else if (location?.pathname === '/promotions' || location?.pathname === `/${currentLanguage}/promotions`)
            setActive('promotions')
        else if (location?.pathname === '/transactions' || location?.pathname === `/${currentLanguage}/transactions`)
            setActive('transactions')
        else if (location?.pathname === '/profile' || location?.pathname === `/${currentLanguage}/profile`)
            setActive('profile')
        else if (location?.pathname === '/settings' || location?.pathname === `/${currentLanguage}/settings`)
            setActive('settings')
        else if (location?.pathname === '/favorites' || location?.pathname === `/${currentLanguage}/favorites`)
            setActive('favorites')
        else if (location?.pathname === '/trade' || location?.pathname === `/${currentLanguage}/trade`)
            setActive('trade')
            // else if (location?.pathname === '/poker')
        //     setActive('poker')
        else if (location?.pathname === '/casino/virtual_sports' || location?.pathname === `/${currentLanguage}/casino/virtual_sports`)
            setActive('virtual_sports')

        else if (location?.pathname?.includes('/group/')) {

            const myPath = getPluckedPath(location.pathname)
            const t1 = slotCasinoGroups?.find(oo => oo.slug === myPath)
            const t2 = liveCasinoGroups?.find(oo => oo.slug === myPath)

            if (!t1 && !t2) {
                let tActive;
                if (location?.pathname?.includes('/casino/slots'))
                    tActive = 'slots'
                if (location?.pathname?.includes('/group/lobby'))
                    tActive = 'lobby'
                else if (location?.pathname?.includes('/group/popular'))
                    tActive = 'popular-games'
                else if (location?.pathname?.includes('/group/new-releases'))
                    tActive = 'new-releases'
                else if (location?.pathname?.includes('/group/free-spins'))
                    tActive = 'free-spins'
                else if (location?.pathname?.includes('/group/enhanced-rtp'))
                    tActive = 'enhanced-rtp'
                else if (location?.pathname?.includes('/group/instant-win'))
                    tActive = 'instant-win'
                else if (location?.pathname?.includes('/group/jackpot-games'))
                    tActive = 'jackpot-games'
                else if (location?.pathname?.includes('/group/bonus-buy'))
                    tActive = 'bonus-buy'
                else {
                    if (location?.pathname?.includes('/group/live-casino'))
                        setActive('live-casino')
                    else if (location?.pathname?.includes('/group/live-lobby'))
                        setActive('live-lobby')
                    else if (location?.pathname?.includes('/group/table-games'))
                        setActive('table-games')
                    else if (location?.pathname?.includes('/group/roulette'))
                        setActive('roulette')
                    else if (location?.pathname?.includes('/group/poker'))
                        setActive('poker')
                    else if (location?.pathname?.includes('/group/blackjack'))
                        setActive('blackjack')
                    else if (location?.pathname?.includes('/group/baccarat'))
                        setActive('baccarat')

                    return setCollapsed(['live-casino'])
                }


                setActive(tActive)
                setCollapsed(['slots'])

            } else {
                setActive('')
            }

        } else if (location?.pathname?.includes('/sportsbook')) {
            let tActive;
            if (location?.pathname?.includes('/sportsbook/soccer'))
                tActive = 'soccer'
            else if (location?.pathname?.includes('/sportsbook/basketball'))
                tActive = 'basketball'
            else if (location?.pathname?.includes('/sportsbook/american-football'))
                tActive = 'american-football'
            else if (location?.pathname?.includes('/sportsbook/upcoming'))
                tActive = 'upcoming'

            else if (location?.pathname?.includes('/sportsbook/live-betting'))
                tActive = 'live-betting'
            else if (location?.pathname?.includes('/sportsbook/baseball'))
                tActive = 'baseball'
            else if (location?.pathname?.includes('/sportsbook/tennis'))
                tActive = 'tennis'
            else if (location?.pathname?.includes('/sportsbook/table-tennis'))
                tActive = 'table-tennis'
            else if (location?.pathname?.includes('/sportsbook/volleyball'))
                tActive = 'volleyball'
            else if (location?.pathname?.includes('/sportsbook/mma'))
                tActive = 'mma'
            else if (location?.pathname?.includes('/sportsbook/ice-hockey'))
                tActive = 'ice-hockey'
            if (tActive) {
                setActive(tActive)
                setCollapsed(['sportsbook'])
            }


        } else if (location?.pathname?.includes('/casino/category/')) {

            if (location?.pathname?.includes('/casual'))
                setActive('casual')
            else if (location?.pathname?.includes('/lottery'))
                setActive('lottery')
            else if (location?.pathname?.includes('/craps'))
                setActive('craps')
            else if (location?.pathname?.includes('/fishing'))
                setActive('fishing')
            else if (location?.pathname?.includes('/mines'))
                setActive('mines')
            else if (location?.pathname?.includes('/scratch'))
                setActive('scratch')
                // else if (location?.pathname?.includes('/virtual_sports'))
            //     setActive('virtual_sports')
            else
                setActive('exclusive')

            setCollapsed(['exclusive'])

        } else if (location?.pathname === '/' || location?.pathname === `/${currentLanguage}` || location?.pathname === `/${currentLanguage}/`)
            setActive('homepage')

        else setActive(location.pathname)
    }, [location?.pathname, currentLanguage])

    useEffect(() => {
        const allButtons = document.querySelectorAll('.sidebar__scheme button');

        const allButtonsSmall = document.querySelectorAll('.sidebar__scheme-small button');


        StyleHelper.setThemeButtons(configuration);

        allButtons.forEach(button => {
            button?.addEventListener('click', function () {
                const themeValue = button.getAttribute('data-bs-theme-value');
                document.documentElement.setAttribute('data-bs-theme', themeValue);
                StyleHelper.setThemeButtons(configuration);

            });
        });

        allButtonsSmall.forEach(button => {
            button?.addEventListener('click', function () {
                const themeValue = button.getAttribute('data-bs-theme-value');
                console.log('themeValue2 = ', themeValue)

                document.documentElement.setAttribute('data-bs-theme', themeValue);
                StyleHelper.setThemeButtons(configuration);
            });
        });

    }, [authenticated, configuration])


    function workOnClassAdd() {

        console.log('workOnClassAdd SIDEBAR ACTIVE = ')
        if (agent?.isMobile) {
            store.dispatch({
                type: GLOBAL_CONSTANTS.SET_SIDEBAR_SHOW,
                data: true
            })
        }
    }

    function workOnClassRemoval() {
        console.log("I'm triggered when the class is removed")
        setCollapsed([])

        const content = document.getElementById('sidebar-content')

        content?.scroll({
            top: 0
        })

        if (agent?.isMobile) {
            store.dispatch({
                type: GLOBAL_CONSTANTS.SET_SIDEBAR_SHOW,
                data: false
            })
        }
    }

    useEffect(() => {
        let targetNode = document.getElementById('sidebar')
        new ClassWatcher(targetNode, 'active', workOnClassAdd, workOnClassRemoval)
    }, [agent?.isMobile])


    const [correction, setCorrection] = useState({})
    useEffect(() => {
        if (!selectedWallet?.code || !agent?.isMobile) return;

        associateServices.checkCorrection({
            code: selectedWallet.code
        }).then(res => {
            if (res?.data && parseFloat(res?.data?.required_wager || 0) > 0) {
                let dt = res?.data
                dt.percentage = parseFloat(Big(res?.data?.wagered_currency || res?.data?.wagered || 0).div(res?.data?.required_wager_currency || res?.data?.required_wager || 1)
                    .times(100).toFixed(2))

                setCorrection(dt)
            } else {
                setCorrection({})
                clearInterval(interval);
            }
        });

        const interval = setInterval(() => {
            associateServices.checkCorrection({
                code: selectedWallet.code
            }).then(res => {
                if (res?.data && parseFloat(res?.data?.required_wager || 0) > 0) {
                    let dt = res?.data
                    dt.percentage = parseFloat(Big(res?.data?.wagered_currency || res?.data?.wagered || 0).div(res?.data?.required_wager_currency || res?.data?.required_wager || 1)
                        .times(100).toFixed(2))

                    setCorrection(dt)
                } else {
                    setCorrection({})
                    clearInterval(interval);
                }
            });
        }, 20000); // 20 seconds

        return () => clearInterval(interval);

    }, [selectedWallet?.code, agent?.isMobile]);


    useEffect(() => {
        if (document.querySelector('.sidebar')) {
            const sidebar = document.querySelector('.sidebar');
            const sidebarBtn = document.querySelector('.sidebar__btn');
            const bottomMenuBtn = document.querySelector('.lowbar__btn--menu');

            var screenWidth = window.innerWidth;

            function toggleHeaderMenu() {
                sidebar?.classList?.toggle('active');
                bottomMenuBtn?.classList?.toggle('active');
            }

            sidebarBtn?.addEventListener('click', toggleHeaderMenu);
            bottomMenuBtn?.addEventListener('click', toggleHeaderMenu);

            document.addEventListener('click', function (e) {
                if (sidebar?.classList?.contains('active') && screenWidth < 1200) {
                    var isClickInside01 = sidebar.contains(event.target);
                    var isClickButton01 = sidebarBtn.contains(event.target);
                    var isClickButton02 = bottomMenuBtn.contains(event.target);

                    if (!isClickInside01 && !isClickButton01 && !isClickButton02) {
                        sidebar?.classList?.remove('active');
                        bottomMenuBtn?.classList?.remove('active');
                    }
                }
            });
        }
    }, [])

    const [showBonusModal, setShowBonusModal] = useState(false)
    useEffect(() => {
        if (activeLanguage?.key && selectedWallet?.code) {
            associateServices.getBonusRequestContent({
                code: selectedWallet.code,
                language: activeLanguage?.key,
            }).then(res => {
                setShowBonusModal(Object.keys(res?.data)?.length >= 1)
            })
        }
    }, [selectedWallet?.code, activeLanguage?.key])

    const [requestingCall, setRequestingCall] = useState(false)

    const handleCallRequest = () => {
        if (requestingCall)
            return


        setRequestingCall(true)

        associateServices.makeCallRequest({}).then(res => {

            toast(<InformationToast
                icon={'ti-info-circle'}
                title={t(`general.information`)}
                message={t(`api-notifications.${res?.data}`)}
            />)

            setRequestingCall(false)

        })
    }


    useEffect(() => {
        if (activeLanguage?.key) {
            associateServices.getSidebarGameGroups({
                language: activeLanguage.key
            }).then(res => {

                const l1 = res?.data?.live || []
                setLiveCasinoGroups(Array.isArray(l1) ? l1 : Object.values(l1))

                const c1 = res?.data?.slots || []
                setSlotCasinoGroups(Array.isArray(c1) ? c1 : Object.values(c1))


            })
        }
    }, [activeLanguage?.key])
    return (

        <div className="sidebar" id="sidebar">

            <div className="sidebar__head">
                <button className="sidebar__btn" type="button">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <line x1={4} x2={20} y1={12} y2={12}/>
                        <line x1={4} x2={20} y1={6} y2={6}/>
                        <line x1={4} x2={20} y1={18} y2={18}/>
                    </svg>
                </button>
                <Link to={stringHelper.getLocalizedPath(currentLanguage, '/')} className="sidebar__logo"/>
            </div>


            <div className="sidebar__content" id="sidebar-content">

                <div className="sidebar__big">


                    <div className="sidebar__links">
                        <Link to={stringHelper.getLocalizedPath(currentLanguage, '/casino')}
                              style={{
                                  background: `url(${configuration?.casino_bg}) no-repeat left center/cover`
                              }}
                              className={`sidebar__link sidebar__link--casino ${active === 'sportsbook' ? 'passive' : ''}`}>
                                        <span>
                                         {t('header.casino')}
                                        </span>
                        </Link>


                        <Link to={stringHelper.getLocalizedPath(currentLanguage, '/sportsbook')}
                              style={{
                                  background: `url(${configuration?.sportsbook_bg}) no-repeat left center/cover`
                              }}
                              className={`sidebar__link sidebar__link--casino ${active === 'casino' ? 'passive' : ''}`}>
                                        <span>
                                         {t('header.sports')}
                                        </span>
                        </Link>

                    </div>

                    {
                        showBonusModal &&
                        <div className="sidebar__links">
                            <Link
                                to={stringHelper.getLocalizedPath(currentLanguage, '?modal=bonus-request')}
                                style={{
                                    background: `url(https://cdn.ebetlab.com/request-bonus.png) no-repeat left center/cover`
                                }}
                                className={`sidebar__link sidebar__link--bonus w-100`}>
                                <span>
                                    {t('bonus-request.modal-title', 'Request Bonus')}
                                        </span>
                            </Link>
                        </div>
                    }

                    {
                        authenticated && <>
                            {
                                correction?.id && <>
                                    <Link
                                        to={stringHelper.getLocalizedPath(currentLanguage, `?modal=vip&tab=correction`)}
                                        id="correction-button"
                                        className="correction-button-mobile sidebar__links"
                                        style={{
                                            '--border-width': `${correction.percentage}%`
                                        }}
                                    >

                                        {t('modals.vip.tabs.correction')}

                                        <span className="small">
                                                                    {`(${correction.percentage}%)`}
                                                                </span>
                                    </Link>
                                </>
                            }
                        </>
                    }


                    <div className="sidebar__menu">
                    <span className="sidebar__title">
                        {t('sidebar.menu')}
                    </span>
                        <ul className="sidebar__nav sidebar__nav--border">

                            <li className={active === 'homepage' ? 'active' : ''}>
                                <Link
                                    to={stringHelper.getLocalizedPath(currentLanguage, '/')}>
                                    <SvgIcon id={'homepage'}/>
                                    {t('sidebar.home')}
                                </Link>
                            </li>
                            <li className={active === 'vip' ? 'active' : ''}>
                                <Link to={stringHelper.getLocalizedPath(currentLanguage, '/vip')}>
                                    <SvgIcon id={'vip'}/>
                                    {t('sidebar.vip-club')}

                                </Link>
                            </li>


                            <li className={active === 'challenges' ? 'active' : ''}>
                                <Link to={stringHelper.getLocalizedPath(currentLanguage, '/challenges')}>
                                    <SvgIcon id={'challenge'}/>
                                    {t('challenges.title')}
                                </Link>
                            </li>


                            {
                                configuration?.wheel_able && <li className={active === 'wheel' ? 'active' : ''}>
                                    <Link to={stringHelper.getLocalizedPath(currentLanguage, '/wheel')}>
                                        <WheelIcon/>
                                        {t('wheel.title', 'Wheel')}
                                    </Link>
                                </li>
                            }


                            {
                                configuration?.stream_enabled &&
                                <li className={active === 'streams' ? 'active' : ''}>
                                    <Link to={stringHelper.getLocalizedPath(currentLanguage, '/streams')}>
                                        <SvgIcon id={'stream'}/>
                                        {t('streams.title')}
                                    </Link>
                                </li>
                            }


                            <li className={active === 'blog' ? 'active' : ''}>
                                <Link to={stringHelper.getLocalizedPath(currentLanguage, '/blog')}>
                                    <SvgIcon id={'blog'}/>
                                    {t('sidebar.blog')}
                                </Link>
                            </li>

                            {
                                authenticated && configuration?.call_me_able &&
                                <li className={''}>
                                    <a onClick={handleCallRequest}>
                                        <SvgIcon id={'phone'}/>
                                        {t('general.request-call-me', 'Beni Ara')}
                                    </a>
                                </li>
                            }

                            {/*{*/}
                            {/*    configuration?.stream_enabled &&*/}
                            {/*    <li className={active === 'streams' ? 'active' : ''}>*/}
                            {/*        <Link to={stringHelper.getLocalizedPath(currentLanguage, '/streams')}>*/}
                            {/*            <SvgIcon id={'stream-1'}/>*/}
                            {/*            {t('sidebar.streams','Streams')}*/}

                            {/*        </Link>*/}
                            {/*    </li>*/}
                            {/*}*/}


                            <li className={active === 'casino' ? 'active' : ''}>
                                <Link to={stringHelper.getLocalizedPath(currentLanguage, '/casino')}>
                                    <SvgIcon id={'casino2'}/>
                                    {t('sidebar.casino')}
                                </Link>
                            </li>


                            <li className={active === 'sportsbook' ? 'active' : ''}>
                                <Link to={stringHelper.getLocalizedPath(currentLanguage, '/sportsbook')}>
                                    <SvgIcon id={'sportsbook-basketball'}/>
                                    {t('sidebar.sportsbook')}
                                </Link>
                            </li>


                            <li className={active === 'e-sport' ? 'active' : ''}>
                                <Link to={stringHelper.getLocalizedPath(currentLanguage, '/e-sport')}>
                                    <SvgIcon id={'gamer'}/>
                                    {t('sidebar.e-sport', 'E-Sport')}
                                </Link>
                            </li>


                            {
                                authenticated && <li className={active === 'favorites' ? 'active' : ''}>
                                    <Link to={stringHelper.getLocalizedPath(currentLanguage, '/favorites')}>
                                        <SvgIcon id={'icon-favourited'}/>
                                        {t('sidebar.favorites')}

                                    </Link>
                                </li>
                            }


                            {
                                configuration?.pokerklas_able ?
                                    <li className={active === 'poker' ? 'active' : ''}>
                                        <Link to={stringHelper.getLocalizedPath(currentLanguage, '/poker')}>
                                            <SvgIcon id={'pokr-side'}/>
                                            {t('sidebar.poker', 'Poker')}
                                            <span>{t('general.new', 'New')}</span>
                                        </Link>
                                    </li> : null
                            }

                            {
                                configuration?.trade_able ?
                                    <li className={active === 'trade' ? 'active' : ''}>
                                        <Link to={stringHelper.getLocalizedPath(currentLanguage, '/trade')}>
                                            <SvgIcon id={'chart'}/>
                                            {t('sidebar.trade')}
                                            <span>{t('general.new')}</span>
                                        </Link>
                                    </li> : null
                            }
                        </ul>


                        <ul className="sidebar__nav sidebar__nav--border">

                            <span className="sidebar__title">
                               {t('sidebar.games')}
                            </span>


                            <li className={active === 'slots' ? 'active' : ''}>

                                <Link className="no-bg"
                                      to={stringHelper.getLocalizedPath(currentLanguage, [24, 37]?.includes(configuration?.w_id) ? '/casino/group/lobby' : '/casino/slots')}>
                                    <SvgIcon id={'slots2'}/>
                                    {t('sidebar.slots')}
                                </Link>


                                <button
                                    className={`sidebar__collapsed ${collapsed?.includes('slots') ? '' : 'collapsed'}`}
                                    type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapse-menu1"
                                    // aria-expanded="false"
                                    aria-expanded={collapsed?.includes('slots') ? 'true' : 'false'}
                                    aria-controls="collapse-menu1">
                                    <SvgIcon id={'arrow-right'}/>
                                </button>
                            </li>

                            <ul id="collapse-menu1"
                                className={`sidebar__nav sidebar__nav--border sidebar__nav--collapse collapse ${collapsed?.includes('slots') ? 'show' : ''}`}>

                                {
                                    slotCasinoGroups?.length >= 1 ?
                                        <li
                                            className={active === 'lobby' ? 'active' : ''}>
                                            <Link
                                                to={stringHelper.getLocalizedPath(currentLanguage, '/casino/group/lobby')}>
                                                <SvgIcon id={'slots'}/>
                                                {t(`sidebar.lobby`)}
                                            </Link>
                                        </li>

                                        :
                                        gameTypes?.map(gameType => (
                                            <li key={gameType?.key}
                                                className={active === gameType?.key ? 'active' : ''}>
                                                <Link
                                                    to={stringHelper.getLocalizedPath(currentLanguage, gameType?.path)}>
                                                    <SvgIcon id={gameType?.icon}/>
                                                    {t(`sidebar.${gameType?.key}`)}
                                                </Link>
                                            </li>
                                        ))
                                }


                                {
                                    slotCasinoGroups?.map(gameType => (
                                        <li key={gameType?.id} id={`${gameType?.slug}-${gameType?.id}`}
                                            className={location?.pathname?.includes(`/casino/group/${gameType?.slug}`) ? 'active' : ''}>
                                            {/*className={active === gameType?.key ? 'active' : ''}>*/}
                                            <Link
                                                state={{title: gameType?.title, image: gameType?.image}}
                                                to={stringHelper.getLocalizedPath(currentLanguage, `/casino/group/${gameType?.slug}`)}>
                                                {
                                                    gameType?.image && gameType?.image !== 'https://cdn.ebetlab.com/' &&
                                                    <img src={gameType?.image} alt={gameType?.image}
                                                         className="svg-icon"/>
                                                }
                                                {gameType?.title}
                                            </Link>
                                        </li>
                                    ))
                                }


                            </ul>


                            <li>
                                <Link className="no-bg"
                                      to={stringHelper.getLocalizedPath(currentLanguage, [24, 37]?.includes(configuration?.w_id) ? '/casino/group/live-lobby' : '/live-casino')}>
                                    <SvgIcon id={'live-casino'}/>
                                    {t('sidebar.live-casino')}
                                </Link>
                                <button
                                    className={`sidebar__collapsed ${collapsed?.includes('live-casino') ? '' : 'collapsed'}`}
                                    type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapse-menu2"
                                    aria-expanded={collapsed?.includes('live-casino') ? 'true' : 'false'}
                                    aria-controls="collapse-menu2">
                                    <SvgIcon id={'arrow-right'}/>
                                </button>
                            </li>


                            <ul id="collapse-menu2"
                                className={`sidebar__nav sidebar__nav--border sidebar__nav--collapse  collapse ${collapsed?.includes('live-casino') ? 'show' : ''}`}>

                                {
                                    liveCasinoGroups?.length >= 1 ?
                                        <li
                                            className={active === 'live-lobby' ? 'active' : ''}>
                                            <Link
                                                to={stringHelper.getLocalizedPath(currentLanguage, '/casino/group/live-lobby')}>
                                                <SvgIcon id={'live-lobby'}/>
                                                {t(`sidebar.live-lobby`)}
                                            </Link>
                                        </li>

                                        :
                                        liveCasinoTypes?.map(gameType => (
                                            <li key={gameType?.key}
                                                className={active === gameType?.key ? 'active' : ''}>
                                                <Link
                                                    state={{title: gameType?.title, image: gameType?.image}}
                                                    to={stringHelper.getLocalizedPath(currentLanguage, gameType?.path)}>
                                                    <SvgIcon id={gameType?.icon}/>
                                                    {t(`sidebar.${gameType?.key}`)}
                                                </Link>
                                            </li>
                                        ))
                                }

                                {
                                    liveCasinoGroups?.map(gameType => (
                                        <li key={gameType?.id} id={`${gameType?.slug}-${gameType?.id}`}
                                            className={location?.pathname?.includes(`/casino/group/${gameType?.slug}`) ? 'active' : ''}>
                                            <Link
                                                to={stringHelper.getLocalizedPath(currentLanguage, `/casino/group/${gameType?.slug}`)}>
                                                {
                                                    gameType?.image && gameType?.image !== 'https://cdn.ebetlab.com/' &&
                                                    <img src={gameType?.image} alt={gameType?.image}
                                                         className="svg-icon"/>
                                                }
                                                {gameType?.title}
                                            </Link>
                                        </li>
                                    ))
                                }


                            </ul>


                            <li className={active === 'sportsbook' ? 'active' : ''}>

                                <Link
                                    to={stringHelper.getLocalizedPath(currentLanguage, '/sportsbook')}
                                    className="no-bg">
                                    <SvgIcon id={'sportsbook2'}/>
                                    {t('sidebar.sportsbook')}
                                </Link>
                                <button
                                    className={`sidebar__collapsed ${collapsed?.includes('sportsbook') ? '' : 'collapsed'}`}
                                    type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapse-menu4"
                                    // aria-expanded="false"

                                    aria-expanded={collapsed?.includes('sportsbook') ? 'true' : 'false'}

                                    aria-controls="collapse-menu4"><SvgIcon id={'arrow-right'}/></button>


                            </li>


                            <ul id="collapse-menu4"
                                className={`sidebar__nav sportsbook sidebar__nav--collapse  collapse ${collapsed?.includes('sportsbook') ? 'show' : ''}`}>

                                {
                                    sportsbookTypes?.map(gameType => (
                                        <li key={gameType?.key} className={active === gameType?.key ? 'active' : ''}>
                                            <Link
                                                to={stringHelper.getLocalizedPath(currentLanguage, gameType?.path)}>
                                                <SvgIcon id={gameType?.icon}/>
                                                {t(`sidebar.${gameType?.key}`)}
                                            </Link>
                                        </li>
                                    ))
                                }

                            </ul>


                            {/*<li className={active === 'exclusive' ? 'active' : ''}>*/}
                            {/*    <Link*/}
                            {/*        to={stringHelper.getLocalizedPath(currentLanguage, '/casino/category/exclusive')}*/}
                            {/*        className="no-bg">*/}
                            {/*        <SvgIcon id={'exclusive'}/>*/}
                            {/*        {t('sidebar.exclusive')}*/}
                            {/*    </Link>*/}
                            {/*    <button*/}
                            {/*        className={`sidebar__collapsed ${collapsed?.includes('exclusive') ? '' : 'collapsed'}`}*/}
                            {/*        type="button" data-bs-toggle="collapse"*/}
                            {/*        data-bs-target="#collapse-menu5"*/}
                            {/*        aria-expanded={collapsed?.includes('exclusive') ? 'true' : 'false'}*/}
                            {/*        aria-controls="collapse-menu5"><SvgIcon id={'arrow-right'}/></button>*/}


                            {/*</li>*/}

                            {/*<ul id="collapse-menu5"*/}
                            {/*    className={`sidebar__nav sidebar__nav--collapse  collapse ${collapsed?.includes('exclusive') ? 'show' : ''}`}>*/}

                            {/*    {*/}
                            {/*        exclusiveGameTypes?.map(gameType => (*/}
                            {/*            <li key={gameType?.key} className={active === gameType?.key ? 'active' : ''}>*/}
                            {/*                <Link*/}
                            {/*                    to={stringHelper.getLocalizedPath(currentLanguage, gameType?.path)}>*/}
                            {/*                    <SvgIcon id={gameType?.icon}/>*/}
                            {/*                    {t(`sidebar.${gameType?.key}`)}*/}
                            {/*                </Link>*/}
                            {/*            </li>*/}
                            {/*        ))*/}
                            {/*    }*/}

                            {/*</ul>*/}

                            {/*<li className={active === 'virtual_sports' ? 'active' : ''}>*/}
                            {/*    <Link className="no-bg"*/}
                            {/*          to={stringHelper.getLocalizedPath(currentLanguage, '/casino/virtual_sports')}>*/}
                            {/*        <SvgIcon id={'virtual-sports'}/>*/}
                            {/*        {t('sidebar.virtual_sports')}*/}
                            {/*    </Link>*/}

                            {/*</li>*/}

                        </ul>


                        {
                            authenticated &&
                            <ul className="sidebar__nav sidebar__nav--border">
                                <span className="sidebar__title">
                                    {t('sidebar.account')}
                                </span>

                                <li className={active === 'account' ? 'active' : ''}>

                                    <a
                                        className="no-bg"
                                        onClick={e => {
                                            setActive('account')
                                            setCollapsed(['account'])
                                        }}
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapse-menu3"
                                        aria-expanded={collapsed?.includes('account') ? 'true' : 'false'}
                                    >
                                        <SvgIcon id={'profile'}/>
                                        {t('sidebar.account')}
                                    </a>
                                    <button
                                        className={`sidebar__collapsed ${collapsed?.includes('account') ? '' : 'collapsed'}`}
                                        type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapse-menu3"
                                        aria-expanded={collapsed?.includes('account') ? 'true' : 'false'}
                                        aria-controls="collapse-menu3">
                                        <SvgIcon id={'arrow-right'}/>
                                    </button>


                                </li>

                                <ul id="collapse-menu3" className="sidebar__nav sidebar__nav--collapse collapse">
                                    <li>
                                        <Link
                                            to={stringHelper.getModalPath('wallet', searchParams)}
                                        >
                                            <SvgIcon id={'wallet'}/>
                                            {t('sidebar.wallet')}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to={stringHelper.getModalPath('vip', searchParams)}
                                        >
                                            <SvgIcon id={'vip-club'}/>
                                            {t('sidebar.vip')}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to={stringHelper.getModalPathStatistics('statistics', '', searchParams)}
                                        >
                                            <SvgIcon id={'statistics'}/>
                                            {t('sidebar.statistics')}
                                        </Link>
                                    </li>
                                    <li className={active === 'settings' ? 'active' : ''}>
                                        <Link
                                            to={stringHelper.getLocalizedPath(currentLanguage, '/settings')}>
                                            <SvgIcon id={'profile'}/>
                                            {t('sidebar.profile')}
                                        </Link>
                                    </li>
                                    <li className={active === 'transactions' ? 'active' : ''}>
                                        <Link
                                            to={stringHelper.getLocalizedPath(currentLanguage, `/transactions`)}>
                                            <SvgIcon id={'transactions'}/>
                                            {t('sidebar.transactions')}
                                        </Link>
                                    </li>


                                </ul>


                                <li>
                                    <Link
                                        to={stringHelper.getLocalizedPath(currentLanguage, '/affiliate')}
                                    >
                                        <SvgIcon id={'affiliate'}/>
                                        {t('header.affiliate')}
                                    </Link>
                                </li>
                            </ul>
                        }


                        <SidebarRaces active={active}/>


                        <div className="sidebar__menu">
                        <span className="sidebar__title">
                            {t('sidebar.additional-info')}
                        </span>
                            <ul className="sidebar__nav">
                                <li>
                                    <a onClick={handleLiveSupport}>
                                        <SvgIcon id={'head-set'}/>
                                        {t('sidebar.live-support')}
                                    </a>
                                </li>
                                <li className={active === 'policy' ? 'active' : ''}>
                                    <Link
                                        to={stringHelper.getLocalizedPath(currentLanguage, '/policy')}>
                                        <SvgIcon id={'privacy'}/>
                                        {t('sidebar.privacy-policy')}
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>


                    <div
                        className={`sidebar__actions ${configuration?.has_themes ? '' : 'd-flex justify-content-end'}`}>
                        {
                            configuration?.has_themes &&
                            <div className="sidebar__scheme">
                                <button className="active" type="button" data-bs-theme-value="dark">
                                    {/*<i className="ti ti-moon"/>*/}
                                    <SvgIcon id={'dark-mode'}/>
                                </button>
                                <button type="button" data-bs-theme-value="light">
                                    {/*<i className="ti ti-sun"/>*/}
                                    <SvgIcon id={'light-mode'}/>

                                </button>
                            </div>
                        }
                        <SidebarLanguage/>
                    </div>


                </div>

                <SidebarSmall
                    races={[]}
                    raffles={[]}
                    authenticated={authenticated} active={active}
                    // handleNavigation={handleNavigation}
                />
            </div>

        </div>


    )

}

export default Sidebar
